import { Outlet, useMatch } from 'react-router-dom';

import { Routes } from '@app/constants/routes';

import { TypedNavigate } from '@app/router';
import { useSrcUrlQueryParam } from '@app/modules/auth/hooks/useSrcUrlQueryParam';

export const RootModule: React.FC = () => {
  const [srcUrl] = useSrcUrlQueryParam();
  const isRoot = useMatch(Routes.index);

  if (isRoot) {
    return <TypedNavigate to={Routes.auth.index} queryParams={srcUrl} />;
  }

  return <Outlet />;
};
